<template>
  <div>
    <el-row v-show="false">
      <el-col>
        <el-input v-model="name" size="mini" placeholder="收货人姓名" style="width: 180px;margin-right: 20px"></el-input>
        <el-input v-model="phone" size="mini" placeholder="收货人手机" style="width: 180px;margin-right: 20px"></el-input>
        <el-button type="primary" size="mini">查询</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button type="primary" size="mini" style="margin:20px 0" @click="editAddr()">新增发货地址</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border :data="addrData"  style="font-size: 12px; width: 1000px" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
          <el-table-column  label="ID" type="index" :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="contactName" label="联系人" width="100px"></el-table-column>
          <el-table-column  prop="pcc" label="所在地区" width="160px"></el-table-column>
          <el-table-column  prop="addr" label="详细地址" ></el-table-column>
          <el-table-column  prop="mobile" label="手机号" width="120px"></el-table-column>
          <el-table-column width="120px" label="是否默认地址">
            <template slot-scope="scope">
              <span v-show="scope.row.def == 1" style="line-height: 50px; font-size:14px; font-weight: bold; color: #FF0000">默认地址</span>
              <el-button v-show="scope.row.def == 0" type="text" size="mini" @click="setDef(scope.row)">设为默认地址</el-button>
            </template>
          </el-table-column>
          <el-table-column width="160px;height:40px;">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editAddr(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="delAddr(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="发货地址"  :close-on-click-modal="false"     :visible.sync="showAddr"      width="700px"      center>
      <el-row>
        <span class="adrlabel" >地址信息：</span>
        <el-cascader :key=id v-model="code"  :options="cities" placeholder="请选择省 / 市 / 区" style="width:500px"  @change="handleChange"></el-cascader>
      </el-row>
      <el-row style="margin-top: 20px;">
        <span class="mltlabel">详细地址：</span>
        <el-input v-model="addr" :rows="2" type="textarea" size="mini" style="width:500px" minlength="5"  placeholder="详细地址"></el-input>
      </el-row>
      <el-row style="margin-top: 20px;">
        <span class="adrlabel">发货人姓名：</span>
        <el-input v-model="contactName" size="small" style="width:500px"  placeholder="不超过25个字符"></el-input>
      </el-row>
      <el-row style="margin-top: 20px;">
        <span class="adrlabel">手机号码：</span>
        <el-input v-model="mobile" size="small" style="width:500px"  placeholder="手机号码"></el-input>
      </el-row>
      <el-row style="margin-top: 20px;">
        <span class="adrlabel"></span><el-checkbox v-model="def">设为默认发货地址</el-checkbox>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddr = false">取 消</el-button>
        <el-button type="primary" @click="addAddr">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
    import storage from "../api/storage";
    import $api from "../api/axios";

    export default {
        name: "Address",
      data(){
          return{
            showAddr:false,
            isNew: true,
            code:[],
            id:0,
            contactName:'',
            addr:'',
            mobile:'',
            def:0,
            name:'',
            phone:'',
            province: "",
            city: "",
            country: "",
            addrData:[
              //{id:1,contactName:'张总',pcc:'河南省 郑州市 金水区', addr:'朝凤路36号亚太明猪5号楼1单元1702',mobile:'15645874587',def:true},
                //{id:2,contactName:'张总',pcc:'北京 北京市 东城区',addr:'河南省郑州市经开区管理局',mobile:'15645874587',def:false}
              ]
          }
      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        init(){
          this.$axios.get('/static/js/citys.json').then(res => {
            this.cities = res.data;
          })
        },
        getAddress(){
          let param={
            nick: storage.get('nick')
          }
          $api.post("/setup/getAddr", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
                this.addrData = dataResult.data;
            }
          })
        },
        //添加信息
        addAddr(){
          let def = 0;
          if(this.def)
            def = 1;
          let url = "/setup/addAddr";
          if(!this.isNew)
            url = "/setup/updateAddr"
          if(this.code.length == 0){
            this.$message.error("请选择所在地区！");
            return;
          }
          if(this.addr.length < 5){
            this.$message.error("详细地址不能少于5个字！");
            return;
          }
          if(this.contactName.length == 0){
            this.$message.error("请输入发货人姓名！");
            return;
          }
          if(this.mobile.length < 11){
            this.$message.error("手机号不能小于11位！");
            return;
          }
          const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          if(!reg.test(this.mobile)){
            this.$message.error("手机号格式不正确！");
            return;
          }
          let param={
            id: this.id,
            nick:storage.get('nick'),
            province: this.province,
            city: this.city,
            country: this.country,
            addr: this.addr,
            contactName: this.contactName,
            mobile: this.mobile,
            def: def
          }
          $api.post(url, param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getAddress();
              this.showAddr =false;
            }
          })
        },
        //删除信息
        delAddr(row){
          this.$confirm("确认删除该条地址么？", "删除", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            let param={
              id: row.id,
            }
            $api.post("/setup/delAddr", param, response=>{
              let dataResult = response.data;
              if(dataResult.state == 1){
                this.getAddress();
              }
            })
          })
        },
        //设置默认地址
        setDef(row){
          let param={
            id: row.id,
            nick:storage.get('nick'),
          }
          $api.post("/setup/setDef", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getAddress();
            }
          })
        },
        //打开窗口
        editAddr(row) {
          if (row == undefined) {
            this.isNew = true;
            this.id = 0;
            this.addr = '';
            this.code = [];
            this.mobile = '';
            this.contactName = '';
            this.def = '';
          } else {
            this.isNew = false;
            this.id=row.id;
            this.addr = row.addr;
            this.enCode(row.pcc);
            this.mobile = row.mobile;
            this.contactName = row.contactName;
            this.def = row.def;
            this.handleChange(this.code);
          }
          this.showAddr = true;
        },
        //把代码转化为字符
        handleChange(code) {
          //遍历省
          for(let i=0;i<this.cities.length;i++){
            let p=this.cities[i]
            if(p.value == code[0]){
              console.log(p.label)
              this.province = p.label;
              //市
              for(let j=0; j<p.children.length;j++) {
                let c = p.children[j]
                if(c.value == code[1]){
                  console.log(c.label)
                  this.city = c.label;
                  for(let k=0; k<c.children.length;k++){
                    let a=c.children[k];
                    if(a.value == code[2]){
                      console.log(a.label)
                      this.country = a.label;
                      break;
                    }
                  }
                  break;
                }
              }
              break;
            }
          }
          console.log(this.selected);
        },
        //字符转为代码
        enCode(v){
          let s =v.split(' ');
          for(let i=0;i<this.cities.length;i++){
            let p=this.cities[i]
            if(p.label == s[0]){
              console.log(p.label)
              this.code[0] = p.value;
              //市
              for(let j=0; j<p.children.length;j++) {
                let c = p.children[j]
                if(c.label == s[1]){
                  console.log(c.label)
                  this.code[1] = c.value;
                  for(let k=0; k<c.children.length;k++){
                    let a=c.children[k];
                    if(a.label == s[2]){
                      console.log(a.label)
                      this.code[2] = a.value;
                      break;
                    }
                  }
                  break;
                }
              }
              break;
            }
          }
          console.log(this.code);
        }
      },
      mounted(){
          this.init();
          this.getAddress();
      }
    }
</script>

<style scoped>
  .adrlabel{
    display:inline-block;
    width: 90px;
    text-align: right;
  }
  .mltlabel{
    line-height: 50px;
    display:inline-block;
    width: 90px;
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/print/Address.vue